import { base } from './base';
import { cover } from './cover';
import { quiz } from './quiz';
import { themes } from './themes';
import { view } from './view';
import { layout } from './layout';
import { combineReducers } from 'redux';

const curator = combineReducers({
	base,
	cover,
	quiz,
	themes,
	view,
	layout
});

export default curator;
